<mat-toolbar color="accent">{{ title() }}</mat-toolbar>

<mat-dialog-content class="!text-black">
  <div class="flex flex-col gap-4">
    <div>
      Are you sure you want to start the campaign run for
      <strong>
        {{ approvingEntriesCount$ | async }} of {{ data.entries.length }}
        {{ data.entries.length > 1 ? 'entries' : 'entry' }}
      </strong>
    </div>
    @if (sharedContactDetailsCount()) {
      <div>
        {{ sharedContactDetailsCount() }} entries share contact details.
        Including them could result in the same person getting more than one
        message.
      </div>
      <mat-checkbox [formControl]="skipSharedContactDetails">
        Skip entries that share contact details
      </mat-checkbox>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button type="button" mat-stroked-button mat-dialog-close>Cancel</button>
    <button type="submit" mat-flat-button color="primary" (click)="submit()">
      {{ submitLabel() }}
    </button>
  </pt-buttons-container>
</mat-dialog-actions>
